import { getAPI, postAPI } from "../../api"
import { REACT_APP_TIMESHEET, REACT_APP_JOB } from "../../utils/common"

export async function updateTimeSheet(body: any){  
    const Details = postAPI( REACT_APP_TIMESHEET + '/provider-timesheet', body)
    return Details
}

export async function getTimeSheet(body: any, search: string, pageNumber: number, pageSize: number) {
    const Details = postAPI( REACT_APP_TIMESHEET + `/contract-timesheet?search=${search}&page=${pageNumber}&size=${pageSize}`, body)
    return Details
}

export async function getTimeSheetDetails(timeSheetId?: string, projectId?: string) {
    const Details = getAPI( REACT_APP_TIMESHEET + `/timesheet-details/${timeSheetId}?projectId=${projectId}`)
    return Details
}

export async function SentTimesheetRequest(body?: any) {
    const Details = postAPI( REACT_APP_TIMESHEET + `/timesheet-submit-request`, body)
    return Details
}

export async function getProjects(candidateId: string) {
    const Details = getAPI( REACT_APP_JOB + `/candidate-project-list/${candidateId}`)
    return Details
}


export async function getPayPeriod(body: any) {
    const Details = postAPI( REACT_APP_TIMESHEET + '/project-timesheets', body)
    return Details
}

export async function getHistory(timesheetId: string) {
    const Details = getAPI( REACT_APP_TIMESHEET + `/timesheet-status-history/${timesheetId}`)
    return Details
}

export async function resendTimesheet(body: any) {
    const Details = postAPI( REACT_APP_TIMESHEET + '/timesheet-resend', body)
    return Details
}

export async function extractTimesheetDownload(body: any) {
    const Details = postAPI( REACT_APP_TIMESHEET + '/timesheet-extract', body)
    return Details  
}
